import config from 'constants/config'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { createSelector } from 'reselect'

/**
 * Whether the member can opt in to paying their LuxPlus+ renewal with Société points.
 * Points can only be used in the member's Société account region.
 */
const getCanPayLuxPlusRenewalWithPoints = createSelector(
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (isCurrentRegionUserLoyaltyRegion): boolean =>
    config.LUXURY_PLUS_RENEWAL_POINTS_PAYMENT_ENABLED && isCurrentRegionUserLoyaltyRegion,
)

export default getCanPayLuxPlusRenewalWithPoints
